module.exports = __webpack_public_path__ + "media/img/iryo/extra-luggage-a9c27e0d059e82029d85579415e08074.jpg";